

















import Vue from 'vue'
import { AppRelease } from '../../../models';
import UIBadge from '../UIComponents/UIBadge.vue';
import UIButton from '../UIComponents/UIButton.vue';
import { checkForNewReleases, storeReleaseDate, getStoredReleaseDate } from '../../../util/app-release';
import moment from 'moment'
import { notificationIntervals } from '../../../types/app_release'
import * as Sentry from '@sentry/vue';
import { customLogger } from '../../../plugins/sentry/customLogger';

let checkIntervalId: NodeJS.Timeout | null = null;
let initialTimeout: NodeJS.Timeout | null = null;
const iconsList = ['🚀', '🌟', '💫', '✨', '🆕', '🙂', '👋']

export default Vue.extend({
  components: {
    UIBadge,
    UIButton,
  },
  props: {
    user: Object,
  },
  data() {
    return {
      isShowReleaseNotes: false,
      initialLoad: true,
      iconsList,
      textContent: 'App update is available!',
      isHovered: false,
      randomIndex: Math.floor(Math.random() * iconsList.length),
      isSidebarShow: false,
    }
  },
  async mounted() {
    const isIgnored = await AppRelease.isIgnored(this.user?.companyId,this.user?.id)
    if(!isIgnored){
      this.registerAppReleases();
      this.setupRealTimeListener();
    }
    else{
      this.isShowReleaseNotes = false;
    }
  },
  destroyed() {
    checkIntervalId ? clearInterval(checkIntervalId) : '';
    initialTimeout ? clearTimeout(initialTimeout) : '';
  },
  methods: {
    async registerAppReleases() {
      this.setupInterval();
      
    },
    async setupRealTimeListener() {
      const lastReleaseDate = getStoredReleaseDate()
      const hotFixesRef = AppRelease.listenToHotFixes(lastReleaseDate);
      hotFixesRef.onSnapshot((snapshot) => {
        snapshot.docChanges().forEach((change) => {
          if (change.type === 'added' && !this.initialLoad) {
            this.isShowReleaseNotes = true;
            this.randomIndex = Math.floor(Math.random() * iconsList.length)
            this.setupInterval();
          }
        });
        this.initialLoad = false;
      });
    },
    reloadWindow(e: Event) {
      e.stopImmediatePropagation();
      this.metricsToSentry('App_Release_Refreshed')
      this.closeWidget();
      window.location.reload()
    },
    closeWidget() {
      this.isShowReleaseNotes = false;
      storeReleaseDate(moment())
      this.setupInterval();
      this.metricsToSentry('App_Release_Closed')
    },
    setupInterval() {
      checkIntervalId ? clearInterval(checkIntervalId) : '';
      checkIntervalId = setInterval(() => {
        checkForNewReleases().then((release) => {
          if (release) {
            this.isShowReleaseNotes = true;
            this.randomIndex = Math.floor(Math.random() * iconsList.length)
          }
        });
      }, notificationIntervals.releaseCheckInterval);
    },
    onHover(state: boolean) {
      this.isHovered = state;
      this.textContent = state ? 'Click to refresh!' : 'App update is available!';
    },
    metricsToSentry(type:string){
      customLogger({message: type, level: 'info', tags: {
        user_id: this.user?.id,
        company_id: this.user?.companyId,
        locationId: this.$route.params.location_id ?? ''
      }})
    }
  },
  computed: {
    isCollapseSideBar() {
      return this.$store.getters.getManualCollapseSidebar
    },
    hideSidebar() {
      return this.$route.meta?.hideSideBar 
    },
  },
  watch: {
    '$route': function() {
      setTimeout(() => {
        this.isSidebarShow = document.querySelector('#sidebar-v2') ? false : true
      }, 100)
    }
  }
})
